// IMPORT _maps.js
// IMPORT _embedded-map.js

jQuery(document).ready(function(jQuery){
	
	//Maps.init();
	//Maps_embedded.init();
	
	// Check if we have map objects.
	///if( jQuery('.map-embed, .map-canvas').size() )
	///{
		///console.log('HELLO MAPS!!!');
		
		/*
		jQuery.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyDlLkRAK3nafONBbApJsX6bLKL3mE48bZo&sensor=false', function() {
            console.log('G Maps has LOADED!!!!');
            Maps.init();
			Maps_embedded.init();
        });
        */
		
        //window.loadGoogleMaps();
    ///}
	
});

